<template>
    <div v-if="isAuthorized">
        <!-- Заголовок страницы -->
        <div class="section-title forms">
            <span>{{ $t("modules.app.additional_npa.header.title") }}</span>
        </div>

        <!-- Подзаголовок страницы -->
        <div class="section-subtitle" style=" text-transform: none; font-size: 17px">
          <span style="flex: 1;">
        {{$t('modules.app.additional_npa.header.' + titleNpa)}}
            </span>
            <instruction-view :title="titleNpa"></instruction-view>
        </div>

        <loading
            :active="isFetching === true"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
            style="z-index: 10000!important;"
        />

        <b-card class="table-container">
            <b-table
                 sticky-header="true"
                :fields="tableFields"
                :items="visibleTableRows"
            >
                <template v-slot:head(other)="data">
                        <b-form-checkbox
                            :title="takeActiveNpa ?  $t('modules.app.additional_npa.massage_tools.show_all_npa') : $t('modules.app.additional_npa.massage_tools.show_active_npa')"
                            v-model="takeActiveNpa"
                            name="check-button"
                            v-b-tooltip.hover
                            switch> </b-form-checkbox>

                </template>
                <template #cell(action)="data">
                </template>

                <template #cell(title_ru)="data">
                    {{ data.item[$t("modules.app.additional_npa.lang.name")] }}
                </template>

                <template #cell(form)="data">
                    <a href="#" @click="openRule(data.item.ref)">{{data.item[$t("modules.app.additional_npa.lang.act_acceptance")]}}</a>
                </template>

                <template #cell(npa_type)="data">
                    {{ getNpaTypeOptionText(data.item.npaType) }}
                </template>

                <template #cell(note)="data">
                    {{ data.item.description }}
                </template>

                <template #cell()="data">
                    <b-dropdown id="dropdown-dropleft" dropleft class="more">
                        <template v-slot:button-content>
                            <i class="icon icon-more"></i>
                        </template>
                        <template>
                            <b-dropdown-item
                                v-if="isActiveToUpdate(data)"
                                @click="openModalAndUpdateForm(data.item)">
                                {{ $t("modules.app.additional_npa.tools.edit") }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="openModal">
                                {{ $t("modules.app.additional_npa.tools.add") }}
                            </b-dropdown-item>
<!--                            <b-dropdown-item-->
<!--                                v-if="isActiveToDelete(data)"-->
<!--                                @click="showConfirmModal(data.item.id)">-->
<!--                                {{ $t("modules.app.additional_npa.tools.delete") }}-->
<!--                            </b-dropdown-item>-->
                        </template>
                    </b-dropdown>
                </template>
            </b-table>

            <div class="table-footer">
                <div class="table-buttons" style="margin-top: 7px">
                    <b-button variant="primary" @click="openModal" class="with-icon">
                        <i class="icon icon-plus-circle"></i>
                        {{ $t("modules.app.additional_npa.tools.add") }}
                    </b-button>
                </div>
            </div>
        </b-card>

        <b-modal
            id="modal-prevent-closing"
            ref="modal"
            size="lg"
            :title="$t('modules.app.additional_npa.tools.add') + ' / ' + $t('modules.app.additional_npa.tools.edit')"
            @hidden="resetModal"
            centered
            content-class="modal-forms"
        >

            <form ref="form" @submit.stop.prevent="addAndCloseNpa">
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.category')"
                    label-for="category-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-select
                        v-model="currentCategory"
                        class="form-select"
                        disabled-field="notEnabled"
                        :state="validateState('currentCategoryList')"
                        aria-describedby="input-0-live-feedback"
                    >
                        <option v-for="option in categoryOptions" :value="option.value" :key="option.value">
                            {{$t('modules.app.additional_npa.header.' + option.value)}}
                        </option>
                    </b-form-select>
                    <div style="margin-top: 10px">
                        <b-button pill variant="outline-danger"
                                  v-for="(category, index) in $v.form.currentCategoryList.$model"
                                  :key="index"
                                  @click="deleteCategory(index)" active
                                  size="sm"
                        >
                            {{$t('modules.app.additional_npa.header.' + category.value)}}
                            &#10006;
                        </b-button>
                    </div>

                    <b-form-invalid-feedback
                        id="input-0-live-feedback"
                    >
                        {{ $t('modules.app.additional_npa.modal-info.required-category-msg') }}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.header.npa')"
                    style="font-weight: bold"
                    label-for="title-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-select
                        :disabled="isVisibilityLocked"
                         v-model="isGlobalRegion"
                        :options="levelNpaOptions"
                    />
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.title')"
                    style="font-weight: bold"
                    label-for="title-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-textarea
                        id="title-input"
                        required
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        v-model="$v.form.title_ru.$model"
                        :state="validateState('title_ru')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-textarea>

                    <b-form-invalid-feedback
                        id="input-1-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>

                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.title') + ' (каз)'"
                    style="font-weight: bold"
                    label-for="title-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-textarea
                        id="title-input"
                        required
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        v-model="$v.form.title_kz.$model"
                        :state="validateState('title_kz')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-textarea>

                    <b-form-invalid-feedback
                        id="input-1-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>

                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.act-acceptance')"
                    style="font-weight: bold"
                    label-for="form-input"
                    class="form-flex"
                    label-align-sm="left"
                >
                    <b-form-textarea
                        id="form-input"
                        v-model="$v.form.formTextRu.$model"
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        required
                        :state="validateState('formTextRu')"
                        aria-describedby="input-2-live-feedback"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        id="input-2-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.act-acceptance') + ' (каз)'"
                    style="font-weight: bold"
                    label-for="form-input"
                    class="form-flex"
                    label-align-sm="left"
                >
                    <b-form-textarea
                        id="form-input"
                        v-model="$v.form.formTextKk.$model"
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        required
                        :state="validateState('formTextKk')"
                        aria-describedby="input-2-live-feedback"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        id="input-2-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.note')"
                    style="font-weight: bold"
                    label-for="note-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-textarea
                        id="note-input"
                        v-model="$v.form.note.$model"
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        required
                        :state="validateState('note')"
                        aria-describedby="input-3-live-feedback"
                    ></b-form-textarea>

                    <b-form-invalid-feedback
                        id="input-3-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.link')"
                    label-for="link-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-textarea
                        id="link-input"
                        v-model="$v.form.formLink.$model"
                        no-resize
                        rows="3" max-rows="4"
                        class="form-input"
                        required
                        :state="validateState('formLink')"
                        aria-describedby="input-4-live-feedback"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                        style="font-weight: bold"
                        id="input-4-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                    :label="$t('modules.app.additional_npa.modal-info.npa-type')"
                    style="font-weight: bold"
                    label-for="npa-type-input"
                    label-align-sm="left"
                    class="form-flex"
                >
                    <b-form-select
                        id="npa-type-input"
                        v-model="$v.form.npaType.$model"
                        :options="npaTypeOptions"
                        value-field="value"
                        text-field="text"
                        class="form-select"
                        :state="validateState('npaType')"
                        aria-describedby="input-npa-type-live-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback
                        id="input-npa-type-live-feedback"
                    >{{ $t('modules.app.additional_npa.modal-info.required-message') }}</b-form-invalid-feedback>
                </b-form-group>
                <template v-if="isEdit">
                    <b-form-group
                        :label="$t('modules.app.additional_npa.modal-info.state')"
                        style="font-weight: bold;"
                        label-for="category-input"
                        label-align-sm="left"
                        class="form-flex"
                    >
                        <b-form-select
                            v-model="$v.form.isActive.$model"
                            :state="validateState('isActive')"
                            class="form-select"
                            disabled-field="notEnabled"
                            aria-describedby="input-5-live-feedback"
                        >
                            <option v-for="option in activeOptions" :value="option.value" :key="option.key">
                                {{$t('modules.app.additional_npa.modal-info.' + option.key)}}
                            </option>
                        </b-form-select>
                        <b-form-invalid-feedback id="input-5-live-feedback">
                            {{ $t('modules.app.additional_npa.modal-info.required-message') }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </template>
            </form>

            <template v-if="!isEdit" #modal-footer>
                <div style="display: flex; align-items: center; justify-content: center; width: 100%;">
                    <b-button
                        variant="primary"
                        class="text-uppercase"
                        @click="addAndCloseNpa"
                        size="sm"
                    >
                        {{ $t("modules.app.additional_npa.tools.save-and-close") }}
                    </b-button>
                </div>
            </template>

            <template v-else-if="isEdit" #modal-footer>
                <div style="display: flex; align-items: center; justify-content: center; width: 100%;">
                    <b-button
                        variant="primary"
                        class="text-uppercase"
                        @click="addAndCloseNpa"
                        size="sm"
                    >
                        {{ $t("modules.app.additional_npa.tools.save") }}
                    </b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueElementLoading from 'vue-element-loading';
import store from '../../services/store';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import axios from 'axios';
import InstructionView from "@/modules/additional-menu/InstructionView.vue";

export default {
    mixins: [validationMixin],
    name: 'additionallyNpa',
    components: {
        InstructionView,
        'loading': VueElementLoading
    },
    data() {
        return {
            SERVER: {
                MASTER: 'MASTER',
                NSI: 'NSI',
                RELEASE: 'RELEASE'
            },
            npaTitleList: [
                {
                    name: 'sgp'
                },
                {
                    name: 'msnp'
                },
                {
                    name: 'ip'
                },
                {
                    name: 'bp'
                },
                {
                    name: 'ib'
                },
                {
                    name: 'pr'
                }
            ],
            titleNpa: '',
            server: null,
            regionCode: null,
            takeActiveNpa: true,
            obl: null,
            region: null,
            id: null,
            isEdit: false,
            isCreate: false,
            currentCategory: '',
            isType: '',
            isGlobalRegion: this.isGlobalNpa,
            form: {
                title_ru: '',
                title_kz: '',
                formTextRu: '',
                formTextKk: '',
                formLink: '',
                note: '',
                npaType: null,
                isActive: null,
                currentCategoryList: []
            },
            npaTypeList: [],
            categoryOptions: [
                { value: 'sgp' },
                { value: 'msnp' },
                { value: 'ip' },
                { value: 'bp' },
                { value: 'ib' },
                { value: 'pr' }
            ],
            activeOptions: [
                { value: null, key: 'select-state' },
                { value: true, key: 'isActive' },
                { value: false, key: 'notActive' }
            ],
            tableFields: [
                {
                    key: 'action',
                    label: ' ',
                    thStyle: { width: '1%' }
                },
                {
                    key: 'title_ru',
                    label: this.$t('modules.app.additional_npa.modal-info.title'),
                    thStyle: { width: '40%' }
                },
                {
                    key: 'form',
                    label: this.$t('modules.app.additional_npa.modal-info.act-acceptance'),
                    thStyle: { width: '35%' }
                },
                {
                    key: 'npa_type',
                    label: this.$t('modules.app.additional_npa.modal-info.npa-type'),
                    thStyle: { width: '21%' }
                },
                {
                    key: 'note',
                    label: this.$t('modules.app.additional_npa.modal-info.note'),
                    thStyle: { width: '21%' }
                },
                {
                    key: 'other',
                    label: '',
                    thStyle: { width: '3%' }
                }
            ],
            npaList: [],
            isFetching: false,
            titleFields: {
                ru: [
                    {
                        key: 'title_ru',
                        label: 'Заголовок НПА'
                    },
                    {
                        key: 'form',
                        label: 'Форма НПА и орган, принявший акт'
                    },

                    {
                        key: 'npa_type',
                        label: 'Тип НПА'
                    },

                    {
                        key: 'note',
                        label: 'Примечание'
                    }
                ],
                kk: [
                    {
                        key: 'title_ru',
                        label: 'НҚА Тақырыбы'
                    },
                    {
                        key: 'form',
                        label: 'НҚА Нысаны және актіні қабылдаған орган'
                    },
                    {
                        key: 'npa_type',
                        label: 'НҚА түрі'
                    },
                    {
                        key: 'note',
                        label: 'Ескертпе'
                    }
                ],
                en: [
                    {
                        key: 'title_ru',
                        label: 'Header RLA'
                    },
                    {
                        key: 'form',
                        label: 'Form of RLC and the body that adopted the act'
                    },
                    {
                        key: 'npa_type',
                        label: 'Type NPA'
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    }
                ]
            }
        };
    },
    validations: {
        form: {
            title_ru: {
                required,
                minLength: minLength(1)
            },
            title_kz: {
                required,
                minLength: minLength(1)
            },
            formTextRu: {
                required,
                minLength: minLength(1)
            },
            formTextKk: {
                required,
                minLength: minLength(1)
            },
            formLink: {
                required,
                minLength: minLength(1)
            },
            note: {},
            npaType: {
                required
            },
            isActive: {
                required
            },
            currentCategoryList: {
                required,
                minLength: minLength(1)
            }
        }
    },
    methods: {
        getNpaTypeOptionText(code) {
            if (code === null) {
                return null;
            }

            const option = this.npaTypeOptions.find(item => item.value === code);

            return option?.text || code;
        },
        validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
        isAuthorized() {
            return store.state.user.authorized;
        },
        async getObl() {
            let region = this.region;
            try {
                const result = await fetch('/api/dict/get-budget-obl?obl=' + store.state._instanceCode);

                if (result.status === 200) {
                    const json = await result.json();
                    this.obl = json.obl;
                    this.server = json.server
                    this.regionCode = json.code;
                } else {
                    this.makeToast('danger', 'get-budget-obl', `${result.status} - ${result.statusText}`);
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса get-budget-obl', error.toString());
            }

            try {
                await fetch('/api-py/get-user-regions-by-obl/' + this.obl + '/' + this.usrId)
                    .then(response => response.json())
                    .then(json => {
                        if (json.length && json[0].code) { region = this.regionCode; }
                    });
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса get-user-budget-region', error.toString());
            }
            this.region = region;
        },
        openRule(link) {
            window.open(link);
        },
        resetModal() {
            this.isEdit = false;

            this.id = null;
            this.currentCategory = this.form.currentCategoryList[0].value;
            this.form.title_ru = '';
            this.form.title_kz = '';
            this.form.formTextRu = '';
            this.form.formTextKk = '';
            this.form.formLink = '';
            this.form.note = '';
            this.form.npaType = null;
            this.form.currentCategoryList = this.form.currentCategoryList.slice(0, 1);
            this.form.isActive = null;
            this.isGlobalRegion = this.isGlobalNpa;

            this.$nextTick(() => {
                this.$v.$reset();
            });

            this.$refs.modal.hide();
        },
        async addAndCloseNpa() {
            if (this.isEdit === false) {
                this.form.isActive = true;
            }
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }

            if (!this.server) {
                this.makeToast('danger', 'Ошибка сервера');
                this.resetModal();
                return;
            }

            let category = '';
            for (let i = 0; i < this.form.currentCategoryList.length; i++) {
                if (this.form.currentCategoryList.length - 1 === i) {
                    category += this.form.currentCategoryList[i].value;
                } else {
                    category += this.form.currentCategoryList[i].value + ',';
                }
            }
            const newData = {
                id: this.id,
                code: null,
                code_region: this.regionCode,
                nameRu: this.form.title_ru,
                nameKk: this.form.title_kz,
                act_acceptance_ru: this.form.formTextRu,
                act_acceptance_kk: this.form.formTextKk,
                ref: this.form.formLink,
                description: this.form.note,
                category_act: category,
                npaType: this.form.npaType,
                active: this.form.isActive
            };

            if (this.isGlobalRegion) {
                newData.code_region = null;
            }

            let activeOrDeactivatingDate = new Date(Date.now() - (new Date().getTimezoneOffset() * 1000 * 60)).toJSON().replace(/T/, ' ').split(' ')[0];
            activeOrDeactivatingDate = activeOrDeactivatingDate.replace(/:/g, '-');
            if (this.isEdit === true) {
                if (newData.active === false) {
                    newData.endDate = activeOrDeactivatingDate;
                }
                await this.editData(newData);
            } else {
                newData.begDate = activeOrDeactivatingDate;
                await this.addData(newData);
            }
            await this.loadData();
            this.resetModal();
        },
        openModalAndUpdateForm(data) {
            this.id = data.id;
            this.form.title_ru = data.nameRu;
            this.form.title_kz = data.nameKk;
            this.isGlobalRegion = !data.code_region;
            this.form.formTextRu = data.act_acceptance_ru;
            this.form.formTextKk = data.act_acceptance_kk;
            this.form.formLink = data.ref;
            this.form.note = data.description;
            this.form.npaType = data.npaType || null;
            this.form.currentCategoryList = data.category_act.slice();
            this.form.isActive = data.active;
            this.isEdit = true;
            this.$refs.modal.show();
        },
        openModal() {
            this.isGlobalRegion = this.isGlobalNpa;
            this.$refs.modal.show();
        },
        async addData(newData) {
            this.isFetching = true;
            try {
                await axios.post('/api/dict/npa/save', newData);
                this.isFetching = false;
            } catch (err) {
                console.error(err);
                this.isFetching = false;
            }
        },
        deleteCategory(index) {
            const indexDelete = index + 1;
            this.form.currentCategoryList = this.form.currentCategoryList.slice(0, index).concat(this.form.currentCategoryList.slice(indexDelete));
        },

        isActiveToUpdate(data) {
            const isMaster = this.isMasterServer;
            const isNsi = this.isNsiServer;
            const isRelease = this.isReleaseServer;

            if (isMaster) {
                return true;
            } else if (isNsi) {
                return data.item.code_region === null;
            } else if (isRelease) {
                return data.item.code_region !== null;
            }

            return false;
        },

        isActiveToDelete(data) {
            const isMaster = this.isMasterServer;
            const isNsi = this.isNsiServer;
            const isRelease = this.isReleaseServer;

            if (isMaster) {
                return true;
            } else if (isNsi) {
                return data.item.code_region === null;
            } else if (isRelease) {
                return data.item.code_region !== null;
            }

            return false;
        },

        showConfirmModal(id) {

            this.$bvModal.msgBoxConfirm(`${this.$t('modules.app.additional_npa.massage_tools.confirm_delete')}`, {
                title: `${this.$t('modules.app.additional_npa.massage_tools.confirm')}`,
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: `${this.$t('modules.app.additional_npa.massage_tools.yes')}`,
                cancelTitle: `${this.$t('modules.app.additional_npa.massage_tools.cancellation')}`,
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                  if (value){
                      this.deleteNpa(id)
                  }
                })
                .catch(err => {
                })
        },
        makeToast (variant, tostbody, title) {
            this.$bvToast.toast(tostbody, {
                title: title,
                variant: variant,
                autoHideDelay: 2000,
                solid: true,
                toaster: 'b-toaster-top-center'
            })
        },

        async loadData() {
            const npaLocalList = [];
            this.isFetching = true;
            const currentRegion = this.region;
            try {
                const response = await fetch('/api/dict/npa/region?code_region=' + currentRegion);
                const values = await response.json();
                values.forEach(value => {
                    if (value.category_act !== null && value.category_act.split(',').includes(this.$route.params.typeNpa.split('&')[0])) {
                        const item = {
                            id: value.id,
                            code: value.code,
                            nameRu: value.nameRu,
                            nameKk: value.nameKk,
                            act_acceptance_ru: value.act_acceptance_ru,
                            act_acceptance_kk: value.act_acceptance_kk,
                            ref: value.ref,
                            description: value.description,
                            npaType: value.npaType,
                            active: value.active,
                            code_region: value.code_region
                        };
                        item.abilityToEdit = value.code_region !== null;
                        item._rowVariant =  value.active ? 'none': 'danger'


                        item.category_act = this.categoryPreparation(value.category_act);
                        npaLocalList.push(item);
                    }
                });

                this.npaList = npaLocalList;
            } catch (error) {
                console.error(error);
                this.npaList = [];
            } finally {
                this.isFetching = false;
            }
        },
        async loadNpaTypes() {
            try {
                const response = await fetch('/api/dict/npa_type');

                if (!response.ok) {
                    this.npaTypeList = [];
                    this.makeToast('danger', `${response.status} - ${response.statusText}`,
                        `${this.$t('modules.app.additional_npa.massage_tools.npa_type_fail')}`);

                    return;
                }

                // при 5xx Spring отдаёт JSON-объект ошибки, а не массив — иначе упадёт npaTypeOptions
                const result = await response.json();
                this.npaTypeList = Array.isArray(result) ? result : [];
            } catch (error) {
                console.error(error);
                this.npaTypeList = [];
                this.makeToast('danger', error.toString(),
                    `${this.$t('modules.app.additional_npa.massage_tools.npa_type_fail')}`);
            }
        },
        async editData(editData) {
            this.isFetching = true;
            try {
                await fetch('/api/dict/npa/save', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(editData)
                });
                this.isFetching = false;
            } catch (error) {
                console.error(error);
                this.isFetching = false;
            }
        },

        async deleteNpa(id) {
            try {
                const response = await fetch(`api/dict/npa/${id}`, {
                    method: 'delete'
                })
                if (!response.ok) {
                    this.makeToast('danger', `${this.$t('modules.app.additional_npa.massage_tools.delete_fail')}`, `${this.$t('modules.app.additional_npa.massage_tools.massage')}`);
                } else {
                    this.makeToast('success', `${this.$t('modules.app.additional_npa.massage_tools.delete_ok')}`, `${this.$t('modules.app.additional_npa.massage_tools.massage')}`);
                }
            }  finally {
                await this.loadData();
            }
        },

        categoryPreparation(categoryAct) {
            return categoryAct.split(',').map(el => {
                if (el === 'sgp') {
                    return {
                        value: 'sgp'
                    };
                } if (el === 'msnp') {
                    return {
                        value: 'msnp'
                    };
                } if (el === 'ip') {
                    return {
                        value: 'ip'
                    };
                } if (el === 'bp') {
                    return {
                        value: 'bp'
                    };
                } if (el === 'ib') {
                    return {
                        value: 'ib'
                    };
                } if (el === 'pr') {
                    return {
                        value: 'pr'
                    };
                }
            });
        }
    },
    async created() {
        this.isType = 'preCreate';
        await this.getObl();
        this.currentCategory = this.$route.params.typeNpa.split('&')[0];
        const curNpa = this.npaTitleList.find(el => {
            if (el.name === this.$route.params.typeNpa.split('&')[0]) {
                return el;
            }
        });
        this.titleNpa = curNpa.name;
        await this.loadNpaTypes();
        await this.loadData();
        this.isType = 'created';
    },
    watch: {
        currentCategory: function (val) {
            let selectValue = '';
            this.categoryOptions.forEach(cat => {
                if (cat.value === val) {
                    selectValue = cat.value;
                }
            });
            const isInclude = this.form.currentCategoryList.some((el) => {
                return el.value === selectValue;
            });
            if (!isInclude) {
                this.form.currentCategoryList.push({
                    value: selectValue
                });
            }
        },
        '$route.params.typeNpa': async function (typeNpa) {
            this.npaList = [];
            if (this.isType === 'preCreate') {
                return;
            }
            this.form.currentCategoryList = [];
            this.currentCategory = typeNpa;

            const curNpa = this.npaTitleList.find(el => {
                if (el.name === typeNpa) {
                    return el;
                }
            });
            this.titleNpa = curNpa.name;
            await this.loadData();
        },
        '$i18n.locale': function () {
            this.tableFields.forEach(el => {
                this.titleFields[this.$i18n.locale].forEach(title => {
                    if (el.key === title.key) {
                        el.label = title.label;
                    }
                });
            });
        }
    },
    computed: {
        visibleTableRows() {
            if (this.takeActiveNpa) {
                return this.npaList.filter(npa => npa.active === true);
            } else {
                return this.npaList;
            }
        },
        usrId() {
            if (store.state.user.sub === undefined) { return null; }
            return store.state.user.sub;
        },
        isMasterServer () {
            return  this.server === this.SERVER.MASTER },

        isNsiServer () {
            return this.server === this.SERVER.NSI },

        isReleaseServer () {
            return this.server === this.SERVER.RELEASE },

        isVisibilityLocked() {
            return !this.isMasterServer;
        },

        isGlobalNpa() {
            return (this.isMasterServer || this.isNsiServer)
        },

        levelNpaOptions() {
            return [
                { value: true, text: this.$t('modules.app.additional_npa.header.global') },
                { value: false, text: this.$t('modules.app.additional_npa.header.local') }
            ]
        },

        npaTypeOptions() {
            const nameField = this.$t('modules.app.additional_npa.lang.name');
            const options = this.npaTypeList.map(item => ({
                value: item.code,
                text: `${item.code} - ${item[nameField] || item.nameRu}`
            }));

            return [
                { value: null, text: this.$t('modules.app.additional_npa.modal-info.select-npa-type'), disabled: true },
                ...options
            ];
        }
    }
};
</script>

<style scoped>
.form-input, .form-select {
    min-width: 545px;
    background: #FFFFFF;
    border: 1px solid #BCD2E0;
    border-radius: 5px;
    font-size: 15px;
}
</style>